/* SelectedSiteDetails.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { BodySmall, EyebrowSmall } from '@atlassian/mpac-primitives';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _17 = "._1bto1l2s{text-overflow:ellipsis}";
const _16 = "._o5721q9c{white-space:nowrap}";
const _15 = "._18s8ze3t{margin:var(--ds-space-0,0)}";
const _14 = "._18m915vq{overflow-y:hidden}";
const _13 = "._1reo15vq{overflow-x:hidden}";
const _12 = "._1bsb12it{width:75%}";
const _11 = "._syaz131l{color:var(--ds-text-subtlest,#626f86)}";
const _10 = "._1bsb1ns9{width:-moz-fit-content;width:fit-content}";
const _9 = "._4cvr1h6o{align-items:center}";
const _8 = "._1yt4192h{padding:var(--_170nn8b)}";
const _7 = "@media not all and (min-width:48rem){._14adu2gc{margin-bottom:var(--ds-space-100,8px)}}";
const _6 = "._4cvr1y6m{align-items:flex-start}";
const _5 = "._2lx21bp4{flex-direction:column}";
const _4 = "._1e0c1txw{display:flex}";
const _3 = "._i0dlf1ug{flex-basis:0%}";
const _2 = "._1o9zidpf{flex-shrink:0}";
const _ = "._16jlkb7n{flex-grow:1}";
const selectedSitePanel = null;
const siteTextContainer = null;
const ellipsisContainer = null;
const selectedSiteStyles = null;
export const SelectedSiteDetails = _ref => {
  let {
    selectedSiteUrl
  } = _ref;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_16jlkb7n _1o9zidpf _i0dlf1ug _1e0c1txw _2lx21bp4 _4cvr1y6m _14adu2gc"]),
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_8, _4, _9, _10, _11]
          }), /*#__PURE__*/_jsx(EyebrowSmall, {
            className: ax(["_1yt4192h _1e0c1txw _4cvr1h6o _1bsb1ns9 _syaz131l"]),
            style: {
              "--_170nn8b": ix("var(--ds-space-050, 4px)".concat(" 0"))
            },
            children: "SITE"
          })]
        })
      }), /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_12]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1bsb12it"]),
          children: /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_13, _14, _15, _16, _17]
            }), /*#__PURE__*/_jsx(BodySmall, {
              className: ax(["_1reo15vq _18m915vq _18s8ze3t _o5721q9c _1bto1l2s"]),
              children: selectedSiteUrl === null || selectedSiteUrl === void 0 ? void 0 : selectedSiteUrl.split('//')[1]
            })]
          })
        })]
      })]
    })]
  });
};